import React, { Component } from 'react'
//import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
//import { submitFahrerBatch } from '../actions'
//import { Map } from 'immutable'
import { Link } from 'react-router-dom'
import { Formik, ErrorMessage, Form, Field } from 'formik'
import { updatePassword, fetchUser } from '../actions'

const inputStyle = {
  marginBottom: '10px'
}

class ChangePasswordEditor extends Component {

  componentDidMount() {
 		this.props.actions.fetchUser();
	}

  // Admins werden zur User-Seite gelinkt, alle anderen zur Hauptseite
  cancelLink() {
    var cancelPath = '/';
    const isAdmin = this.isAdmin();
    if (isAdmin) {
      cancelPath = '/user';
    };
    return cancelPath;
  }

  // Ohne auth auch kein admin, ansonsten muss admin in den Rollen aufgeführt sein
  isAdmin() {
    if (!this.props.auth) {
      return false;
    }
    if (this.props.auth.roles.indexOf('admin')>-1) {
      return true;
    } else {
      return false;
    }
  }

  render() {

    var initValues = {
      passwordOld: '',
      password: '',
      passwordNewToo: '',
      username: ''
    };

    if (this.props.auth) {
      initValues.username = this.props.auth.username;
    }

    return (

      <div>
        <h2>Passwort ändern</h2>

        <Formik
          initialValues={initValues}
          enableReinitialize
          validate={(values, touched) => {
            let errors = {};
            if (!values.passwordOld) {
              errors.passwordOld = 'Angabe erforderlich';
            }
            if (!values.password) {
              errors.password = 'Angabe erforderlich';
            }
            if (!values.passwordNewToo) {
              errors.passwordNewToo = 'Angabe erforderlich';
            }
            if (values.passwordNewToo && values.passwordNewToo.length < 6) {
              errors.passwordNewToo = 'Das Passwort muss mindestens aus 6 Zeichen bestehen.'
            }
            if (values.password && values.password.length < 6) {
              errors.password = 'Das Passwort muss mindestens aus 6 Zeichen bestehen.'
            }
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
              setSubmitting(true);
              values.username = this.props.auth.username;
              this.props.actions.updatePassword( values, this.props.history );
              setSubmitting(false);
          }}
        >

          {({ isSubmitting, props, setFieldValue, initValues, values, touched, errors }) => (

            <Form>
              <Field
                name="username"
                type="input"
                disabled
              />
              <label htmlFor="passwordOld">Altes Passwort</label>
              <Field
                name="passwordOld"
                type="password"
                style={inputStyle}
                placeholder="alt"
              />
              <ErrorMessage
                style={{color: 'orange'}}
                name="passwordOld"
                component="div"
              />
              <label htmlFor="password">Neues Passwort</label>
              <Field
                name="password"
                type="password"
                style={inputStyle}
                placeholder="neu"
              />
              <ErrorMessage
                style={{color: 'orange'}}
                name="password"
                component="div"
              />
              <label htmlFor="passwordNewToo">Neues Passwort (bitte wiederholen)</label>
              <Field
                name="passwordNewToo"
                type="password"
                style={inputStyle}
                placeholder="neu"
              />
              <ErrorMessage
                style={{color: 'orange'}}
                name="passwordNewToo"
                component="div"
              />
            { touched.password && touched.passwordNewToo && (values.password !== values.passwordNewToo) &&
                <div
                  style={{color: 'orange'}}>Die neuen Passwörter müssen übereinstimmen.</div>}
              <Link to={this.cancelLink()} style={{marginRight: '10px'}} type="cancel">
                <button className="btn btn-secondary" >
                  <span style={{color: 'white'}}>Abbrechen</span>
                </button>
              </Link>
              <button className="btn btn-default" type="submit" disabled={isSubmitting || false}>
                Absenden
              </button>
            </Form>
          )}
        </Formik>

        <div style={{height: "80px"}}></div>

      </div>
    )}
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ updatePassword, fetchUser }, dispatch)
  }
}

function mapStateToProps({auth}) {
	return { auth }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangePasswordEditor);



// WEBPACK FOOTER //
// ./src/components/ChangePassword.js